import ApiHook from './axiosAPI'

const { apiGET } = ApiHook()

const AnunciosAPI = {
  BuscarAnuncios: async idcidade => {
    const url = `/public/buscarAtivosPorCidade/?idcidade=${idcidade}`
    return await apiGET(url, true)
  },
}

export default AnunciosAPI
